module.exports = __webpack_public_path__ + "static/media/jarvaniv.6c87dbd6.png";